<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<span epub:type="pagebreak" id="p2" title="2">
<p class="copyright2">Copyright © 2016 by General Mills, Minneapolis, Minnesota. All rights reserved.</p>
<p class="copyright1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="copyright1"><a href="http://www.hmhco.com" target="_blank">www.hmhco.com</a></p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data is available.</p>
<p class="copyright1">ISBN 978-0-544-81624-4</p>
<p class="copyright1">Cover photos: <span href="#/html/p278#p278" title="Link target outside of Sample">Fresh Fruit Frozen Yogurt Pops</span>; <span href="#/html/p161#p161" title="Link target outside of Sample">Cheesy Turkey-Spinach Lasagna Roll-Ups</span></p>
<p class="copyright">GENERAL MILLS</p>
<p class="copyright1">Owned Media and Publishing Director: Amy Halford</p>
<p class="copyright1">Owned Media and Publishing Manager: Audra Carson</p>
<p class="copyright1">Senior Editor: Grace Wells and Cathy Swanson</p>
<p class="copyright1">Recipe Development and Testing: Betty Crocker Kitchens</p>
<p class="copyright1">Photography: General Mills Photography Studios and Image Library</p>
<p class="copyright">HOUGHTON MIFFLIN HARCOURT</p>
<p class="copyright1">Publisher: Natalie Chapman</p>
<p class="copyright1">Editorial Director: Cindy Kitchel</p>
<p class="copyright1">Executive Editor: Anne Ficklen</p>
<p class="copyright1">Editorial Associate: Molly Aronica</p>
<p class="copyright1">Managing Editor: Marina Padakis</p>
<p class="copyright1">Production Editor: Helen Seachrist</p>
<p class="copyright1">Cover Design: Tai Blanche</p>
<p class="copyright1">Interior Design and Layout: Tai Blanche</p>
<p class="copyright1">Senior Production Coordinator: Kimberly Kiefer</p>
<p class="copyright3">eISBN 978-0-544-81625-1</p>
<p class="copyright1">v1.0816</p>
<div class="figurecp">
<figure>
<img alt="" src="image/p002.png"/>
</figure>
</div>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p002.vue?1845f7c0